/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const AddDocumentButton = (props) => {
    const setOpen = props?.setOpen;

    const openDialog = () => {
        if (setOpen) {
            setOpen(true);
        }
    };

    return (
        <div 
            className="banner-add-document-button"
            onClick={openDialog}
        >
            <div className="banner-add-document-button-text">Select Document</div>
        </div>
    );
};

AddDocumentButton.displayName = "AddDocumentButton";
export { AddDocumentButton };

